import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("staff_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && !cfg._retry && !cfg.url.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        const { data } = await api.post("/auth/refresh");
        localStorage.setItem("staff_token", data.token);
        return api(cfg);
      } catch {
        localStorage.removeItem("staff_token");
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Algo deu errado. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

const fmt = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo", weekday: "short", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit",
});
export const formatBRT = (iso) => (iso ? fmt.format(new Date(iso)) : "Sem horário");

export function nextSlots(days = 4) {
  const out = [];
  const now = Date.now();
  const brtNow = new Date(now - 3 * 3600 * 1000);
  for (let d = 0; d < days; d++) {
    for (const h of [18, 20, 22]) {
      const t = Date.UTC(brtNow.getUTCFullYear(), brtNow.getUTCMonth(), brtNow.getUTCDate() + d, h + 3);
      if (t > now) out.push(new Date(t).toISOString());
    }
  }
  return out;
}
